import React from "react";

export default React.createContext({
    setBubbleText: () => {},
    setErrorText: () => {},
    setWarningText: () => {},
    setValidText: () => {},
    setEvent: () => {},
    objectPopup: null,
    setObjectPopup: () => {},
    getDatasPopup: null,
    setGetDatasPopup: () => {},
    statePopup: null,
    setStatePopup: () => {},
    subStatePopup: null,
    setSubStatePopup: () => {},
    popupLoadingIcon: null,
    setPopupLoadingIcon: () => {},
    popupLoadingText: null,
    setPopupLoadingText: () => {},
    backgroundTasks: null,
    setBackgroundTasks: () => {},
    typeDeployProcess: null,
    setTypeDeployProcess: () => {}
});